import { Component } from '@angular/core';
import { Note, NoteDefaultValues } from './note';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { NoteService } from 'src/app/services/note.service';
import { MatDialog } from '@angular/material/dialog';
import { NoteFormComponent } from './note-form/note-form.component';
import { faPen, faTrash, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-note',
    templateUrl: './note.component.html',
    styleUrls: ['./note.component.scss'],
    standalone: false
})
export class NoteComponent {
  loggedInUserPublicId: string = '';
  courseId: string = '';
  note: Note = NoteDefaultValues();
  notesList: Note[] = [];
  noteText: string = '';
  faPen: IconDefinition = faPen;
  faTrash: IconDefinition = faTrash;
  participantClassByRole: string = '';
  translations: any;

  constructor (
    private route: ActivatedRoute,
    private authservice: AuthService,
    private noteService: NoteService,
    private dialog: MatDialog,
    private themeService: ParticipantThemeService,
    private translationService: TranslationService
  ) { }

  ngOnInit(): void {
    this.loggedInUserPublicId = this.authservice.getUserLoginData().publicId;

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;

    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });

    this.route.params.subscribe({
      next: (params) => {
        this.courseId = params['id'] ;
      }
    })

    this.getNotes();
  }

  getNotes() {
    this.noteService.getCourseNotesForUser(this.courseId).subscribe({
      next: (response) => {
        this.notesList = response.body;
      }
    });
  }

  openNoteModal(id?: number) {
    if (id) {
      this.updateNote(id);
    } else {
      this.createNote();
    }
  }

  updateNote(id: number) {
    console.log(id);
    this.noteService.getNote(id).subscribe({
      next: (response) => {
        this.noteText = response.body.note;

        const dialogRef = this.dialog.open(NoteFormComponent, {
          data: {
            id: id,
            note: this.noteText
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result != null)
          {
            this.note.id = id;
            this.note.note = result.note;
            this.note.courseId = this.courseId;
            this.note.participantId = this.loggedInUserPublicId;

            this.noteService.updateNote(this.note).subscribe({
              next: () => {
                this.getNotes();
              }
            });
          }
        });
      }
    });
  }

  createNote() {
    const dialogRef = this.dialog.open(NoteFormComponent);

    dialogRef.afterClosed().subscribe(result => {
      if(result != null) {
        this.note.note = result.note;
        this.note.courseId = this.courseId;
        this.note.participantId = this.loggedInUserPublicId;

        this.noteService.createNote(this.note).subscribe({
          next: () => {
            this.getNotes();
          }
        });
      }
    });
  }

  deleteNote(id: number) {
    this.noteService.deleteNote(id).subscribe({
      next: () => {
        this.getNotes();
      }
    });
  }

}
